import AlbumSearchResultListing from './AlbumSearchResultListing';

export default AlbumSearchResultListing;
